<div class="atm-table-table">
  <div class="table-head">
    <div *ngFor="let columnName of columnNames">
      <div [className]="columnName.style">
        <span>{{ columnName.name }}</span>
      </div>
    </div>
  </div>
</div>
